<template>
  <div
    :class="{
      invisible: !hasMediaContent,
      'has-avatar': !isHideAvatar || isKeepAvatarDesign,
      'no-padding': !hasMediaContent,
    }"
    class="content-container"
  >
    <default-overlay />
    <qr-code-component
      :qr-code-data="currentContent?.attrs?.qrCode"
      :has-margin="!!(headline.value || text.value)"
    />
    <media-text
      v-if="headline.value?.trim().length"
      :data="headline"
      :class="{
        headline: true,
        'text-margin': !text.value
      }"
      class="media-text"
      weight="bold"
    />
    <media-text
      v-if="text.value?.trim().length"
      :data="text"
      class="text media-text"
    />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import useContent from '@/composables/useContent';
import useDynamicText from '@/composables/useDynamicText';
import MediaText from '@/components/MediaText';
import QrCodeComponent from '@/components/QrCodeComponent';
import DefaultOverlay from '@/components/DefaultOverlay';

export default defineComponent({
  name: 'MediaComponent',

  components: {
    MediaText,
    DefaultOverlay,
    QrCodeComponent,
  },

  setup() {
    const { currentContent, hasMediaContent, isHideAvatar, isKeepAvatarDesign } = useContent();

    const headlineText = useDynamicText(currentContent.value?.attrs?.headline);
    const textText = useDynamicText(currentContent.value?.attrs?.text);

    const headline = computed(() => ({
      ...headlineText.value,
      fontSize: headlineText.value.fontSize ?? 56,
    }));

    const text = computed(() => ({
      ...textText.value,
      fontSize: textText.value.fontSize ?? 36,
    }));

    return {
      isHideAvatar,
      isKeepAvatarDesign,
      hasMediaContent,
      currentContent,
      headline,
      text,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/common-ui.scss";

.content-container {
  @extend .content-container;
}
</style>
